/* MOVVA | BLACK 2026 | ajustes da página de kits (31-10-2026)
   1) Não envia o campo interno "_Campanha" (o kit já é identificado pelo SKU BM26-KIT...).
   2) Mostra mensagem clara quando o kit não pode ser adicionado ao carrinho.
   3) Completa fotos ausentes das peças com a foto principal do próprio produto.
   4) Regatas Rockers/Icons com preço Black seguem participando dos kits (manga longa continua fora). */
(function () {
  if (!/\/collections\/black-movva-2026\/?$/.test(location.pathname)) return;

  var lastPanel = null;
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[id^="mvbk-kit-"]');
    if (p) lastPanel = p;
  }, true);

  function clearError(panel) {
    var box = panel && panel.querySelector('.mvbk-add-error');
    if (box) box.remove();
  }

  function showError(status, data) {
    var panel = lastPanel || document.querySelector('[id^="mvbk-kit-"]:target');
    if (!panel) return;
    var desc = String((data && (data.description || data.message)) || '');
    var msg;
    if (status === 422 && /esgot|sold out|estoque|quantity|quantidade/i.test(desc)) {
      msg = 'Uma das peças escolhidas acabou de esgotar. Troque o tamanho ou a cor e tente novamente.';
    } else if (status === 422) {
      msg = 'Este kit está indisponível no momento. Atualize a página e tente novamente. Se continuar, fale com a MOVVA pelo WhatsApp (85) 99952-6348.';
    } else if (status === 0) {
      msg = 'Não conseguimos falar com a loja. Verifique sua conexão e tente novamente.';
    } else {
      msg = 'Não foi possível adicionar o kit ao carrinho. Tente novamente ou fale com a MOVVA pelo WhatsApp (85) 99952-6348.';
    }
    clearError(panel);
    var box = document.createElement('p');
    box.className = 'mvbk-add-error';
    box.setAttribute('role', 'alert');
    box.textContent = msg;
    box.style.cssText = 'margin:12px 0 0;padding:12px 14px;border:1px solid #ff4d4d;border-radius:8px;background:rgba(255,77,77,.12);color:#fff;font-size:14px;line-height:1.4;';
    var footer = panel.querySelector('.mvbk-kitpage-footer');
    if (footer && footer.parentNode) footer.parentNode.insertBefore(box, footer);
    else panel.appendChild(box);
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    if (isAdd && init && typeof init.body === 'string') {
      try {
        var body = JSON.parse(init.body);
        if (body && Array.isArray(body.items)) {
          body.items.forEach(function (it) {
            if (it && it.properties) delete it.properties._Campanha;
          });
          init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      } catch (e) {}
    }
    var request = originalFetch.call(this, input, init);
    // 4) Regatas Rockers/Icons com preço Black (ex.: R$ 152,10) continuam participando dos kits.
    //    O seletor da página aceita só variantes de R$ 169,00; aqui normalizamos, apenas para o
    //    seletor, as regatas/camisetas abaixo de R$ 169,00. Manga longa (R$ 199,00) segue fora.
    //    O preço cobrado é sempre o do produto-kit.
    var kitProduct = /\/products\/regata-movva-(rocker|icons)[^\/]*\.js(\?|$)/.test(url);
    if (kitProduct) {
      request = request.then(function (res) {
        if (!res.ok) return res;
        return res.clone().json().then(function (data) {
          (data.variants || []).forEach(function (v) {
            var longa = /manga longa/i.test(String(v.option3 || v.title || ''));
            if (!longa && Number(v.price) < 16900) v.price = 16900;
          });
          return new Response(JSON.stringify(data), { status: res.status, headers: { 'Content-Type': 'application/json' } });
        }).catch(function () { return res; });
      });
    }
    if (isAdd) {
      request.then(function (res) {
        if (res.ok) return;
        res.clone().json().catch(function () { return {}; }).then(function (data) {
          setTimeout(function () { showError(res.status, data); }, 0);
        });
      }, function () {
        setTimeout(function () { showError(0, {}); }, 0);
      });
    }
    return request;
  };

  document.addEventListener('change', function (e) {
    var panel = e.target.closest && e.target.closest('[id^="mvbk-kit-"]');
    if (panel) clearError(panel);
    if (e.target.matches && e.target.matches('.mvbk-print-select')) {
      var slot = e.target.closest('.mvbk-slot');
      if (slot) fillSlotImages(slot, true);
    }
  });

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = originalFetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return cache[handle];
  }

  function imageUrl(product, width) {
    var src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image && product.featured_image.src;
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function placeImage(container, product, width, replace) {
    if (!container) return;
    var img = container.querySelector('img');
    if (img && !(replace && img.hasAttribute('data-mvbk-fix'))) return;
    var url = imageUrl(product, width);
    if (!url) return;
    if (!img) {
      img = document.createElement('img');
      img.setAttribute('data-mvbk-fix', '');
      img.loading = 'lazy';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      container.appendChild(img);
    }
    img.src = url;
    img.alt = product.title || '';
  }

  function fillSlotImages(slot, replace) {
    var chooser = slot.querySelector('.mvbk-print-select');
    var handle = chooser && chooser.value ? chooser.value : slot.dataset.handle;
    if (!handle) return;
    var photo = slot.querySelector('.mvbk-slot-photo');
    var thumb = slot.querySelector('.mvbk-thumb');
    var needs = (photo && (!photo.querySelector('img') || replace)) || (thumb && (!thumb.querySelector('img') || replace));
    if (!needs) return;
    getProduct(handle).then(function (p) {
      placeImage(photo, p, 180, replace);
      placeImage(thumb, p, 160, replace);
    }).catch(function () {});
  }

  function init() {
    document.querySelectorAll('[id^="mvbk-kit-"] .mvbk-slot').forEach(function (slot) { fillSlotImages(slot, false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
